import { z } from "zod";

export const MessageFeedbackSchema = z.object({
  rating: z.enum(["positive", "negative"]),
  reason: z.string().max(1000).optional(),
  tags: z.array(z.enum([
    "helpful",
    "accurate",
    "well_cited",
    "inaccurate",
    "hallucinated",
    "missing_context",
    "wrong_source",
    "too_verbose",
    "too_brief",
    "irrelevant",
  ])).optional(),
  submittedAt: z.string().datetime().optional(),
});

export type MessageFeedback = z.infer<typeof MessageFeedbackSchema>;
